import React, { useEffect, useState } from "react";
import { Card, Button } from "antd";
import moment from "moment";
import { ToWords } from "to-words";
import logo from "../../../../../../../apps/ui/masters-ui/src/app/spsa logo.png";

const toWords = new ToWords({ localeCode: "en-IN" });

export interface QaqcLabPrintProps {
  record: any;
}

export function QaqcLabPrint(props: QaqcLabPrintProps) {
  const [data, setData] = useState<any>(props.record);

  useEffect(() => {
    setData(props.record);
  }, [props.record]);

  const printPage = () => {
    const content = document.getElementById("print-area");

    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=650");

    if (printWindow) {
      printWindow.document.write(`
      <html>
        <head>
          <title>QAQC Lab Certificate Print</title>
          <style>
            @page {
              size: A4;
              margin: 10mm;
            }

            body {
              margin: 0;
              padding: 0;
              font-family: Arial;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            img {
              max-width: 100%;
            }

            button {
              display: none !important;
            }

          </style>
        </head>
        <body>
          ${content.innerHTML}
        </body>
      </html>
    `);

      printWindow.document.close();

      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 500);
    }
  };

  const header = data;

  return (
    <Card
      title="SILK FIBER LAB ANALYSIS CERTIFICATE"
      extra={<Button onClick={printPage}>Print</Button>}
      style={{ width: "100%", margin: 0 }}
      headStyle={{ textAlign: "center", background: "#69c0ff" }}
    >
      <div id="print-area" style={{ padding: 20, position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            opacity: 0.12, 
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          {/* <img
            src={logo}
            alt="watermark"
            style={{
              width: 600,   
              height: "auto",
            }}
          /> */}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            {/* <img src={logo} alt="logo" style={{ height: 80 }} /> */}
          </div>

          <div style={{ textAlign: "center" }}>
            <h2 style={{ margin: 0 }}>S.P.S.A SILKS PVT LTD</h2>
            <p style={{ margin: 0 }}>SILK FIBER LAB ANALYSIS CERTIFICATE</p>
          </div>
          <div></div>
          
        </div>

        <table style={{ width: "100%", marginBottom: 20 }}>
          <tbody>
            <tr>
              <td>
                <b>Work Order No:</b> {header?.workOrderNo || "-"}
              </td>
              <td>
                <b>Test Date:</b>{" "}
                {header?.testDate
                  ? header.testDate
                  : "-"}
              </td>
            </tr>
            
          </tbody>
        </table>

        <div style={{ marginBottom: 20 }}>
          <p>
            <b>Material:</b> {header?.product || "-"}
          </p>
          
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: 20,
          }}
        >
          <thead>
            <tr>
              <th style={th}>Test Parameter</th>
              <th style={th}>Specifications</th>
              <th style={th}>Results</th>
              <th style={th}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={td}>Oil Test</td>
              <td style={td}>0.5 - 1%</td>
              <td style={td}>{header?.oilTest ? `${header.oilTest}%` : "-"}</td>
              <td style={td}>{header?.oilTestRemarks || "-"}</td>
            </tr>
            <tr>
              <td style={td}>Sericin Test</td>
              <td style={td}>2.5 - 3%</td>
              <td style={td}>{header?.sericinTest ? `${header.sericinTest}%` : "-"}</td>
              <td style={td}>{header?.sericinTestRemarks || "-"}</td>
            </tr>
            <tr>
              <td style={td}>Acidity Test</td>
              <td style={td}>1 - 1.5%</td>
              <td style={td}>{header?.acidityTest ? `${header.acidityTest}%` : "-"}</td>
              <td style={td}>{header?.acidityTestRemarks || "-"}</td>
            </tr>
            <tr>
              <td style={td}>PP Content per 200g</td>
              <td style={td}>0.25</td>
              <td style={td}>{header?.ppContent || "-"}</td>
              <td style={td}>{header?.ppContentRemarks || "-"}</td>
            </tr>
            <tr>
              <td style={td}>Moisture Content</td>
              <td style={td}>10 - 11%</td>
              <td style={td}>{header?.moistureContent ? `${header.moistureContent}%` : "-"}</td>
              <td style={td}>{header?.moistureContentRemarks || "-"}</td>
            </tr>
          </tbody>
        </table>

        {header?.remarks && (
          <div style={{ marginBottom: 20 }}>
            <b>Remarks:</b> {header.remarks}
          </div>
        )}

        <table style={{ width: "100%", marginTop: 60 }}>
          <tbody>
            <tr>
              <td style={signTd}></td>
              <td style={signTd}></td>
              <td style={signTd}></td>
            </tr>
            <tr>
              <td style={signTd}>QC</td>
              <td style={signTd}></td>
              <td style={signTd}>HOD</td>
              
            </tr>
          </tbody>
        </table>
      </div>
    </Card>
  );
}

const th = {
  border: "1px solid black",
  padding: 10,
  background: "#fafafa",
};

const td = {
  border: "1px solid black",
  padding: 10,
  textAlign: "center" as const,
};

const signTd = {
  width: "33.33%",        
  textAlign: "center" as const,
  paddingTop: 20,
};
